export default function() {
  /* 表格列头：统一用 min-width，剩余宽度按内容长度比例分配，整行铺满、间隔均匀 */
  return [
    { label: "序号", type: "index", minWidth: 70 },
    { label: "订单状态", prop: "status", slots: "status", minWidth: 100 },
    { label: "openid", prop: "openid", slots: "openid", minWidth: 200 },
    { label: "金额", prop: "money", slots: "money", minWidth: 90 },
    { label: "订单描述", prop: "msg", slots: "msg", minWidth: 180 },
    { label: "备注", prop: "remark", slots: "remark", minWidth: 130 },
    { label: "订单创建时间", prop: "createTime", minWidth: 170 },
    {
      label: "商户单号",
      prop: "out_trade_no",
      slots: "out_trade_no",
      minWidth: 180,
    },
    {
      label: "交易单号",
      prop: "transaction_id",
      slots: "transaction_id",
      minWidth: 160,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 120,
      slots: "operation",
    },
  ];
}
